import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGetVsic from '../../../common/category/useGetVsic'
import { Loading } from '../../../common/loading'
import '../../lang/i18n'
import { getCountries, getUserProfileFields } from '../store/thunk'
import { ContentPopupRequest } from './ContentPopupRequest'

export const PopupRequest = ({
  isOpen,
  onClose,
  userProfile,
  setIsOpenPopupRequest,
}) => {
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const { loading: loadingVsic, vsics } = useGetVsic()

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    dispatch(getCountries({}))
      .unwrap()
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
    dispatch(getUserProfileFields({}))
      .unwrap()
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [locale])

  if (loading || loadingVsic) {
    return <Loading />
  }

  return (
    <ContentPopupRequest
      isOpen={isOpen}
      onClose={onClose}
      userProfile={userProfile}
      setIsOpenPopupRequest={setIsOpenPopupRequest}
      vsics={
        vsics?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        })) || []
      }
    />
  )
}
